import { SUBSCRIPTION_LEVELS, SUBSCRIPTION_NAMES } from '@sdk/account/constants';
import gettext from '@sdk/lang/gettext';

/* eslint-disable */
export const FEATURE_ACCESS = {
  'Shift scheduling': SUBSCRIPTION_LEVELS.FREE,
  'Shift offers': SUBSCRIPTION_LEVELS.FREE,
  'Available shifts': SUBSCRIPTION_LEVELS.FREE,
  Announcements: SUBSCRIPTION_LEVELS.FREE,
  'Task management': SUBSCRIPTION_LEVELS.FREE,
  'Long term scheduling': SUBSCRIPTION_LEVELS.FREE,
  'Unlimited employees': SUBSCRIPTION_LEVELS.FREE,
  'Multiple locations': SUBSCRIPTION_LEVELS.FREE,
  timeclock: SUBSCRIPTION_LEVELS.PREMIUM,
  'Early clock in prevention': SUBSCRIPTION_LEVELS.PREMIUM,
  'Auto clock out': SUBSCRIPTION_LEVELS.PREMIUM,
  'Shift swaps': SUBSCRIPTION_LEVELS.PREMIUM,
  'Shift tags': SUBSCRIPTION_LEVELS.OLD_PREMIUM,
  'SMS shift alarms': SUBSCRIPTION_LEVELS.PREMIUM,
  'Conversation settings': SUBSCRIPTION_LEVELS.OLD_PREMIUM,
  'Newsfeed page settings': SUBSCRIPTION_LEVELS.OLD_PREMIUM,
  'Dedicated account management': SUBSCRIPTION_LEVELS.OLD_PREMIUM,
  'Shift acceptance': SUBSCRIPTION_LEVELS.OLD_PREMIUM,
  Clopening: SUBSCRIPTION_LEVELS.PREMIUM,
  'Schedule templates': SUBSCRIPTION_LEVELS.PREMIUM,
};
/* eslint-enable */

export const subscriptionLevelsPickerOptions = [
  { label: SUBSCRIPTION_NAMES[SUBSCRIPTION_LEVELS.PREMIUM], value: SUBSCRIPTION_LEVELS.PREMIUM },
  { label: SUBSCRIPTION_NAMES[SUBSCRIPTION_LEVELS.BUSINESS], value: SUBSCRIPTION_LEVELS.BUSINESS },
];

export const CANCEL_REASON_SEASONAL = 1;
export const CANCEL_REASON_TOO_EXPENSIVE = 4;
export const CANCEL_REASON_BUSINESS_CLOSING = 7;

export const BUSINESS_DOWNGRADE_REASONS = [
  {
    id: 2,
    reason: gettext('Not finding enough value in the Business features'),
    textRequired: true,
  },
  {
    id: CANCEL_REASON_TOO_EXPENSIVE,
    reason: gettext('The plan is too expensive'),
    textRequired: true,
  },
  { id: 10, reason: gettext('Not using any of the Business features'), textRequired: true },
  { id: 8, reason: gettext('Other'), textRequired: true },
];

export const PREMIUM_CANCEL_REASONS = [
  { id: CANCEL_REASON_BUSINESS_CLOSING, reason: gettext('Our business is closing') },
  { id: CANCEL_REASON_SEASONAL, reason: gettext('Our business is seasonal') },
  { id: CANCEL_REASON_TOO_EXPENSIVE, reason: gettext('The plan is too expensive') },
  { id: 6, reason: gettext('The product is too confusing'), textRequired: true },
  { id: 10, reason: gettext('Going to use another scheduling solution'), textRequired: true },
  {
    id: 2,
    reason: gettext('Not finding enough value in the Premium features'),
    textRequired: true,
  },
  { id: 8, reason: gettext('Other'), textRequired: true },
];

export const BUSINESS_CANCEL_REASONS = [
  { id: CANCEL_REASON_BUSINESS_CLOSING, reason: gettext('Our business is closing') },
  { id: CANCEL_REASON_SEASONAL, reason: gettext('Our business is seasonal') },
  { id: CANCEL_REASON_TOO_EXPENSIVE, reason: gettext('The plan is too expensive') },
  { id: 6, reason: gettext('The product is too confusing'), textRequired: true },
  { id: 10, reason: gettext('Going to use another scheduling solution'), textRequired: true },
  {
    id: 2,
    reason: gettext('Not finding enough value in the Business features'),
    textRequired: true,
  },
  { id: 8, reason: gettext('Other'), textRequired: true },
];

export const PREMIUM_PAUSE_REASONS = [
  { id: CANCEL_REASON_SEASONAL, reason: gettext('Our business is seasonal') },
  { id: CANCEL_REASON_TOO_EXPENSIVE, reason: gettext('The plan is too expensive') },
  { id: 2, reason: gettext('Not finding enough value in the paid features') },
  { id: 8, reason: gettext('Other'), textRequired: true },
];

export const STRIPE_ELEMENTS_DEFAULT_OPTIONS = {
  fonts: [
    {
      src: 'url(https://fonts.gstatic.com/s/opensans/v35/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSKmu0SC55K5gw.woff2)',
      family: 'OpenSans',
      style: 'normal',
    },
  ],
  appearance: {
    variables: {
      fontFamily: 'Helvetica Neue', // TODO: figure out how to use OpenSans here
      colorTextPlaceholder: 'rgba(0, 0, 0, 0.3)',
    },
    rules: {
      '.Label': {
        textTransform: 'uppercase',
        color: '#4C6379',
        fontWeight: '700',
        fontSize: '11px',
      },
      '.Input': {
        fontSize: '14px',
        paddingTop: '0.55rem',
        paddingBottom: '0.55rem',
      },
      '.Input:focus': {
        boxShadow: 'none',
      },
    },
  },
};

export const BILLING_ADDRESS_WARNING_KEY = 'billingAddressWarningModalDismissed';
export const ANNUAL_DISCOUNT_PERCENTAGE = 15;
export const TAX_TIP_VISIBLE_DAYS = 30;

export const PURCHASE_ALLOWED_COUNTRIES = [
  'AU', // Australia
  'CA', // Canada
  'FR', // France
  'DE', // Germany
  'IS', // Iceland
  'IE', // Ireland
  'NZ', // New Zealand
  'PL', // Poland
  'GB', // United Kingdom
  'US', // United States
];
